import { Component, OnDestroy, OnInit } from '@angular/core';
import { CardInputsAbstractInput } from '../card-inputs.abstract-input';
import { FormControl, Validators } from '@angular/forms';

@Component({
    'selector': 'card-inputs-cvc',
    'templateUrl': './card-inputs.cvc.component.html',
    'providers': [],
    'styleUrls': []
})
export class CardInputsCvcComponent extends CardInputsAbstractInput implements OnInit, OnDestroy {

    public displayCvcExplain = false;

    ngOnInit() {
        this.form.addControl('cvc', this.control = new FormControl(
            '',
            [Validators.required, Validators.minLength(3), Validators.maxLength(4)]
        ));
    }
    ngOnDestroy() {
        this.form.removeControl('cvc');
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/card-inputs/cvc/card-inputs.cvc.component.ts